<template>
  <div>
    <vs-prompt @cancel="val=''" blur @accept="save" @close="close" :active.sync="dialog" accept-text="Add"
      title="Add New Satff">
      <div class="con-exemple-prompt">


      </div>
    </vs-prompt>
    <vs-pagination :total="$store.state.cast.all.last_page" v-model="page"></vs-pagination>
    <vs-table :data="$store.state.cast.all.data" sst="true" search @search="handleSearch">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <div @click="dialog = true;cast =def_cast"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New Staff</span>
          </div>
        </div>
      </div>
      <template #thead>
        <vs-th>#</vs-th>
        <vs-th></vs-th>
        <vs-th>name</vs-th>
        <vs-th>works</vs-th>
        <vs-th>role</vs-th>
        <vs-th>actions</vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <vs-tr v-for="(genre,index) in data" :key="index">
            <vs-td>{{genre.id}}</vs-td>
            <vs-td><img :src="`${$baseUrl}/uploads/staff`+genre.photo" class="product-img" width="50" />
            </vs-td>
            <vs-td>{{genre.name}}</vs-td>
            <vs-td>{{genre.works_count}}</vs-td>
            <vs-td>{{genre.role}}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click="edit(genre)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                @click="openConfirm(genre)" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination :total="$store.state.cast.all.last_page" v-model="page"></vs-pagination>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        page: 1,
        query: '',
        dialog: false,
        cast: {
          id: 0,
          name: '',
          role: 0,
          image: '',
          imdb: ''
        },
        def_cast: {
          id: 0,
          name: '',
          role: 0,
          image: '',
          imdb: ''
        }
      }
    },
    watch: {
      page() {
        this.fetchData();
      },
      query(val) {
        this.fetchData();
      },
    },
    created() {
      this.fetchData();
    },
    methods: {
      handleSearch(searching) {
        this.query = searching;
      },
      fetchData() {
        var page = this.page;
        var query = this.query;
        this.$store.dispatch('cast/fetchCasts', {
          page,
          query
        });
      },
      openConfirm(cast) {
        this.cast = cast;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Delete Cast (${cast.name})`,
          text: 'Are you sure to delete this item ?',
          accept: this.del,
          close: this.close
        })
      },
      edit(cast) {
        this.cast = cast;
        this.dialog = true;
      },
      save() {

      },
      close() {
        this.cast = this.def_cast;
      },
      del() {
        this.$store.dispatch('cast/deleteCast', this.cast).then(() => {
          this.$vs.notify({
            color: 'warning',
            title: 'Cast Deleted !',
            text: this.cast.name
          })
          this.cast = this.def_cast;
        });
      }
    },
  }
</script>